import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <path d="M0 14H4V0H0V14ZM8 0V14H12V0H8Z" fill="white" />
    </>
  ),
  'Pause',
  '0 0 11 14'
);
